import type { ReactElement } from "react";
import { ReferenceTypeContainer } from "../../core/containers/domain/masterdataRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  void props.runtime;
  return <ReferenceTypeContainer />;
}

export default Component;
